import { api } from './api';
import type { BrandQuery, BrandQueryAxis, BrandQueryStatus } from '@traaker/shared';

export interface GeneratedQueryProposal {
  text: string;
  textHash: string;
  level?: 'L1' | 'L2' | 'L3' | 'L4' | 'L5' | 'pending';
  zone?: string;
}

export const brandQueriesApi = {
  list: (brandId: string, axis?: BrandQueryAxis) => {
    const params = axis ? `?axis=${axis}` : '';
    return api.get<BrandQuery[]>(`/brands/${brandId}/queries${params}`);
  },

  create: (
    brandId: string,
    body: {
      axis: BrandQueryAxis;
      text: string;
      level?: 'L1' | 'L2' | 'L3' | 'L4' | 'L5' | 'pending';
      zone?: string;
    },
  ) => api.post<BrandQuery>(`/brands/${brandId}/queries`, body),

  update: (
    brandId: string,
    queryId: string,
    body: {
      axis: BrandQueryAxis;
      text?: string;
      zone?: string;
      status?: BrandQueryStatus;
    },
  ) => api.patch<BrandQuery>(`/brands/${brandId}/queries/${queryId}`, body),

  archive: (brandId: string, axis: BrandQueryAxis, queryId: string) =>
    api.delete<{ ok: true }>(`/brands/${brandId}/queries/${axis}/${queryId}`),

  regenerate: (brandId: string, axis: BrandQueryAxis) =>
    api.post<{ proposals: GeneratedQueryProposal[]; geoStrategyHash: string }>(
      `/brands/${brandId}/queries/regenerate`,
      { axis },
    ),

  applyRegen: (
    brandId: string,
    body: {
      axis: BrandQueryAxis;
      geoStrategyHash?: string;
      items: Array<{ text: string; level?: string; zone?: string }>;
    },
  ) =>
    api.post<{
      created: BrandQuery[];
      errors: Array<{ text: string; error: string }>;
    }>(`/brands/${brandId}/queries/regenerate/apply`, body),
};
